'use strict';

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component$1 = videojs.getComponent('Component');

var LanguageMenuContent = function (_Component) {
  inherits(LanguageMenuContent, _Component);

  function LanguageMenuContent(player, options) {
    classCallCheck(this, LanguageMenuContent);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  LanguageMenuContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-language-menu-content vjs-hidden',
      id: 'language-menu-content'
    });
  };

  return LanguageMenuContent;
}(Component$1);

/**
 * @file settings-menu-item.js
 */

var MenuItem = videojs.getComponent('MenuItem');
var playerItem = void 0;
var toTitleCase = function toTitleCase(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

var LanguageMenuItem = function (_MenuItem) {
    inherits(LanguageMenuItem, _MenuItem);

    function LanguageMenuItem(player, options, entry) {
        classCallCheck(this, LanguageMenuItem);

        var _this = possibleConstructorReturn(this, _MenuItem.call(this, player, options));

        _this.player = player;
        _this.subMenuName = toTitleCase(entry);
        _this.lang = entry;
        playerItem = player;

        var update = videojs.bind(_this, _this.update);
        // To update the sub menu value on click, setTimeout is needed because
        // updating the value is not instant

        player.on("ratechange", function () {
            videojs.dom.addClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden');
        });

        _this.update();
        return _this;
    }

    /**
     * Create the component's DOM element
     *
     * @return {Element}
     * @method createEl
     */


    LanguageMenuItem.prototype.createEl = function createEl() {
        // Hide this component by default
        var el = videojs.dom.createEl('li', {
            className: 'vjs-menu-item'
        });

        this.settingsSubMenuTitleEl_ = videojs.dom.createEl('div', {
            className: 'vjs-language-sub-menu-title'
        });

        el.appendChild(this.settingsSubMenuTitleEl_);

        this.settingsSubMenuValueEl_ = videojs.dom.createEl('div', {
            className: 'vjs-language-sub-menu-value'
        });

        el.appendChild(this.settingsSubMenuValueEl_);

        return el;
    };

    /**
     * Handle click on menu item
     *
     * @method handleClick
     */


    LanguageMenuItem.prototype.handleClick = function handleClick() {
        // Remove open class to ensure only the open submenu gets this class
        videojs.dom.removeClass(this.el_, 'open');

        _MenuItem.prototype.handleClick.call(this);

        // Wether to add or remove vjs-hidden class on the settingsSubMenuEl element
        if (videojs.dom.hasClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden')) {
            videojs.dom.removeClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden');
        } else {
            videojs.dom.addClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden');
        }

        if (this.settingsSubMenuEl_ && videojs.dom.hasClass(this.settingsSubMenuEl_, 'vjs-hidden')) {
            videojs.dom.removeClass(this.settingsSubMenuEl_, 'vjs-hidden');
        } else {
            videojs.dom.addClass(this.settingsSubMenuEl_, 'vjs-hidden');
        }
        console.log(this.subMenuName);
        document.getElementById('language_switch_button').firstChild.innerHTML = this.subMenuName;
        this.player.trigger('changeLanguage', this.lang);
    };

    /**
     * Update the sub menus
     *
     * @method update
     */


    LanguageMenuItem.prototype.update = function update() {
        var player = this.player;
        var classQuality = "vjs-settings-sub-menu vjs-hidden";
        classQuality = "vjs-" + this.subMenuName + " " + classQuality;

        //append to component.
        if (this.settingsSubMenuEl_ === undefined) {

            this.settingsSubMenuEl_ = videojs.dom.createEl('div', {
                className: classQuality
            });
            this.settingsSubMenuTitleEl_.innerHTML = this.subMenuName;
            playerItem.getChild("LanguageMenuContent").el().appendChild(this.settingsSubMenuEl_);
            // this.settingsSubMenuEl_.appendChild(this.subMenu.el_);
        }
        // Playback rate menu button doesn't get a vjs-selected class
        // or sets options_['selected'] on the selected playback rate.
        // Thus we get the submenu value based on the labelEl of playbackRateMenuButton

        // Loop trough the submenu items to find the selected child
    };

    /**
     * Hide the sub menu
     */


    LanguageMenuItem.prototype.hideSubMenu = function hideSubMenu() {
        if (videojs.dom.hasClass(this.el_, 'open')) {
            if (this.settingsSubMenuEl_) {
                videojs.dom.addClass(this.settingsSubMenuEl_, 'vjs-hidden');
            }
            videojs.dom.removeClass(this.el_, 'open');
            videojs.dom.addClass(playerItem.getChild("LanguageMenuContent").el(), 'vjs-hidden');
        }
    };

    return LanguageMenuItem;
}(MenuItem);

LanguageMenuItem.prototype.contentElType = 'button';

videojs.registerComponent('LanguageMenuItem', LanguageMenuItem);

/**
 * @file settings-menu-button.js
 */
var MenuButton = videojs.getComponent('MenuButton');
var Menu = videojs.getComponent('Menu');
var Component = videojs.getComponent('Component');

/**
 * The component for controlling the settings menu
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends MenuButton
 * @class SettingsMenuButton
 */

var LanguageMenuButton = function (_MenuButton) {
  inherits(LanguageMenuButton, _MenuButton);

  function LanguageMenuButton(player, options) {
    classCallCheck(this, LanguageMenuButton);

    var _this = possibleConstructorReturn(this, _MenuButton.call(this, player, options));

    _this.addClass('uep-language-menu');
    _this.options = options;
    _this.el_.setAttribute('aria-label', player.localize('language'));
    _this.el_.id = "language_switch_button";
    _this.el_.firstChild.innerHTML = options;
    _this.controlText = player.localize('language');
    _this.showed = false;
    if (_this.el_.children[0]) {
      _this.el_.children[0].addEventListener("mouseover", videojs.bind(_this, _this.showMenu));
    }
    _this.on('click', videojs.bind(_this, _this.hideChildren));
    _this.on('mouseover', videojs.bind(_this, _this.hideChildren));
    return _this;
  }

  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */


  LanguageMenuButton.prototype.handleClick = function handleClick(event) {
    // When you click the button it adds focus, which will show the menu.
    // So we'll remove focus when the mouse leaves the button. Focus is needed
    // for tab navigation.

    this.one(this.menu.contentEl(), 'mouseleave', videojs.bind(this, function (e) {
      this.unpressButton();
      this.el_.blur();
    }));
    if (this.buttonPressed_) {
      document.querySelector('.vjs-language-menu-content').classList.add('vjs-hidden');
      this.unpressButton();
    } else {
      this.pressButton();
    }
  };
  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */


  LanguageMenuButton.prototype.buildCSSClass = function buildCSSClass() {
    // vjs-icon-cog can be removed when the settings menu is integrated in video.js
    return 'vjs-language-menu ' + _MenuButton.prototype.buildCSSClass.call(this);
  };

  /**
   * Create the settings menu
   *
   * @return {Menu} Menu object populated with items
   * @method createMenu
   */

  LanguageMenuButton.prototype.createMenu = function createMenu() {
    var menu = new Menu(this.player());
    var entries = ['fr', 'en'];

    if (entries) {

      var openSubMenu = function openSubMenu() {

        if (videojs.dom.hasClass(this.el_, 'open')) {
          videojs.dom.removeClass(this.el_, 'open');
        } else {
          videojs.dom.addClass(this.el_, 'open');
        }
        document.querySelector('.uep-language-menu .vjs-menu .vjs-menu-content').style.display = "none";
      };

      for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var entry = _ref;

        var settingsMenuItem = new LanguageMenuItem(this.player(), this.options_, entry);

        menu.addChild(settingsMenuItem);

        // Hide children to avoid sub menus stacking on top of each other
        // or having multiple menus open
        settingsMenuItem.on('click', videojs.bind(this, this.hideChildren));

        // Wether to add or remove selected class on the settings sub menu element
        settingsMenuItem.on('click', openSubMenu);
        /*else
        {
          settingsMenuItem.on('click', videojs.bind(this, this.hideChildren));
           console.log("--------------------");
          settingsMenuItem.on('click', videojs.bind(this, this.openHotKey));
         }*/
      }
    }

    return menu;
  };

  /*
   * Hide all the sub menus
   */


  LanguageMenuButton.prototype.hideChildren = function hideChildren() {
    for (var _iterator2 = this.menu.children(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var menuChild = _ref2;

      menuChild.hideSubMenu();
    }
  };

  LanguageMenuButton.prototype.showMenu = function showMenu() {
    document.querySelector('.uep-language-menu .vjs-menu .vjs-menu-content').style.display = "block";
  };

  LanguageMenuButton.prototype.hideMenu = function hideMenu() {
    document.querySelector('.uep-language-menu .vjs-menu .vjs-menu-content').style.display = "none";
  };
  /*
   * Hide all the sub menus
   */

  return LanguageMenuButton;
}(MenuButton);

Component.registerComponent('LanguageMenuButton', LanguageMenuButton);

function utils() {

  return utils.prototype = {
    _updateLang: function _updateLang(lang) {
      videojs.getAllPlayers()[0].language(lang);
      videojs.getAllPlayers()[0].trigger('changeLanguage', lang);
    }
  };
}

window.utils = utils;
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-setting-language');
  player.addChild("LanguageMenuContent", LanguageMenuContent);
  var setting = new LanguageMenuButton(player, options);
  var child = player.getChild("controlBar").addChild(setting, LanguageMenuButton);
  window._defaultMenuComponent = child;
  document.addEventListener('click', function () {
    try {
      document.getElementById('language-menu-content').classList.add('vjs-hidden');
    } catch (e) {
      console.log(e);
    }
  });
  document.addEventListener('touchstart', function () {
    document.getElementById('language-menu-content').classList.add('vjs-hidden');
  });
};
videojs.registerComponent('LanguageMenuContent', LanguageMenuContent);
videojs.registerComponent('LanguageMenuButton', LanguageMenuButton);
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function default
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var settingLanguage = function settingLanguage(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, options);
  });
};

// Register the plugin with video.js.
registerPlugin('settingLanguage', settingLanguage);

// Include the version number.
settingLanguage.VERSION = version;

module.exports = settingLanguage;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_setting_language/dist/videojs-setting-language.cjs.js
// module id = 628
// module chunks = 0